import React, { useState } from "react";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import { useSelector } from "react-redux";
import MahdoodeYaraghTable from "./MahdoodeYaraghTable";
import MahdoodeFaniYaraghTable from "./MahdoodeFani/MahdoodeFaniYaraghTable";
import { read } from "Helpers/LocalStorage";
import { useTranslation } from "react-i18next";
import { Box, Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";

function MahdoodeManager() {
  const { t } = useTranslation();
  const [value, setValue] = useState("1");
  const { selectedBazsho } = useSelector((state) => ({
    selectedBazsho: state.yaragh.selectedBazsho
  }));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {selectedBazsho &&
      ((selectedBazsho.IsG && read("StypeU") === "1") ||
        (!selectedBazsho.IsG &&
          read("yaraghRules")?.accessRegister &&
          (read("StypeU") === "2" || read("StypeU") === "5"))) ? (
        <>
          <TabContext value={value}>
            <Box>
              <TabList onChange={handleChange} variant="scrollable">
                <Tab label={t("MahdoodeYaragh")} value="1" />
                <Tab label={t("MahdoodeFani")} value="2" />
              </TabList>
            </Box>
            <MuiPaper>
              <TabPanel value="1" className="p-0 m-0 ">
                <MahdoodeYaraghTable />
              </TabPanel>
              <TabPanel value="2" className="p-0 m-0">
                <MahdoodeFaniYaraghTable />
              </TabPanel>
            </MuiPaper>
          </TabContext>
        </>
      ) : (
        <MuiPaper>
          <MahdoodeYaraghTable />
        </MuiPaper>
      )}
    </>
  );
}

export default MahdoodeManager;
